export default __webpack_public_path__ + "static/gan-b06f3f9ace638e48afd295fd0f509eee.png";